import { useCallback, useState } from 'react';
import { assetService } from '../services/assetService';

function useAsset() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const getData = useCallback(async (companyId, siteId, assetId) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await assetService.fetchAsset(companyId, siteId, assetId);
      return response.data[0];
    } catch (err) {
      setError(err.message || 'Fetch asset info failed.');
      return [];
    } finally {
      setIsLoading(false);
    }
  }, []);

  return { getData, isLoading, error };
};

export default useAsset;
